var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.692 1.821c.372.373.64.836.778 1.345.793 3.191.61 8.23.016 11.544a3.02 3.02 0 0 1-2.124 2.124c-1.863.508-9.359.508-9.359.508s-7.496 0-9.358-.508A3.02 3.02 0 0 1 .52 14.71C-.277 11.533-.058 6.49.505 3.182A3.02 3.02 0 0 1 2.63 1.058C4.492.55 11.988.534 11.988.534s7.496 0 9.358.508c.509.138.973.406 1.346.779M15.82 8.938 9.603 12.54V5.337z",
    clipRule: "evenodd"
  })));
};
export default SvgYoutube;